<div class="ui-g-12 ui-md-12 ui-lg-12 grid_container">
  <app-server-grid [configuration]="serverGridConfiguration"
                   [(request)]="serverRequest">
  </app-server-grid>
</div>
